// Core imports
import * as React from 'react';

// Components imports
import TrackingTable from 'src/components/TrackingInfo/components/TrackingTable';
import TrackingToolbar from '../components/TrackingToolBar';
import TrackingFilterBar from '../components/TrackingFilterBar';
import TrackingSearchBar from '../components/TrackingSearchBar';
import DateRangeModel from 'src/model/dateRange.model';
import TrackingModel from 'src/model/trackingInfo.model';
import CustomPaginator from 'src/components/common/CustomPaginator';

import './TrackingInfoDesktop.scss';

interface ITrackingDesktopProps {
  t: any;
  trackingContent: TrackingModel[];
  filters: ITrackFilters;
  filterSelected: boolean;
  handleDateFilter(dates: DateRangeModel): void;
  handleSearchText(e: any): void;
  handleOnClickSearch(): void;
  handleSort(sortBy: string, sortIn: string): void;
  handleClearFilters(): void;
  pagination: IPagination;
  handleDesktopPagination?(event: any): void;
  handlePageSizeChange?(event: any): void;
  pageNumber: number;
}

interface IPagination {
  pageNumber: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
}

interface ITrackFilters {
  dates: DateRangeModel | null;
  search: string;
  sortBy: string;
  sortIn: 'ASC' | 'DESC' | 'AUTO';
}

class TrackingDesktop extends React.Component<ITrackingDesktopProps, any> {
  public render() {
    const { t } = this.props;

    const headers = [
      { label: t('tracking.headers.orderNumber'), sortBy: '' },
      { label: t('tracking.headers.orderDate'), sortBy: 'date' },
      { label: t('tracking.headers.confirmationNumber'), sortBy: '' },
      { label: t('tracking.headers.shippedFrom'), sortBy: '' },
      { label: t('tracking.headers.shippedMethod'), sortBy: '' },
      { label: t('tracking.headers.trackNumber'), sortBy: '' }
    ];

    return (
      <div className="rp-tracking-desktop">
        <div className="rp-tracking-filters">
          <TrackingFilterBar
            filters={this.props.filters}
            handleDateFilter={this.props.handleDateFilter}
          />
          <TrackingSearchBar
            mode="Desktop"
            filters={this.props.filters}
            handleSearchText={this.props.handleSearchText}
            handleOnClickSearch={this.props.handleOnClickSearch}
          />
        </div>
        <TrackingToolbar
          filterSelected={this.props.filterSelected}
          onClearClicked={this.props.handleClearFilters}
        />
        <div className="rp-product-tracking--paginator">
          <CustomPaginator
            activePage={this.props.pageNumber ? this.props.pageNumber + 1 : 1}
            totalPages={this.props.pagination.totalPages}
            itemsPerPage={this.props.pagination.pageSize}
            onPageChanged={this.props.handleDesktopPagination}
            totalItems={
              this.props.pagination.totalPages * this.props.pagination.pageSize
            }
            showPageInfo={true}
            onPageSizeChange={this.props.handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={this.props.pagination.pageSize}
          />
        </div>
        <TrackingTable
          trackings={this.props.trackingContent}
          headers={headers}
          handleSort={this.props.handleSort}
          sortBy={this.props.filters.sortBy}
          sortIn={this.props.filters.sortIn}
        />
        <div className="rp-product-tracking--paginator">
          <CustomPaginator
            activePage={this.props.pageNumber ? this.props.pageNumber + 1 : 1}
            totalPages={this.props.pagination.totalPages}
            itemsPerPage={this.props.pagination.pageSize}
            onPageChanged={this.props.handleDesktopPagination}
            totalItems={
              this.props.pagination.totalPages * this.props.pagination.pageSize
            }
            showPageInfo={true}
            onPageSizeChange={this.props.handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={this.props.pagination.pageSize}
          />
        </div>
      </div>
    );
  }
}

export default TrackingDesktop;
